import { render, staticRenderFns } from "./RouteForm.vue?vue&type=template&id=5fa179bf&scoped=true"
import script from "./RouteForm.vue?vue&type=script&lang=js"
export * from "./RouteForm.vue?vue&type=script&lang=js"
import style0 from "./RouteForm.vue?vue&type=style&index=0&id=5fa179bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@1.0.1_vue-template-compiler@2.6.10_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa179bf",
  null
  
)

export default component.exports